import * as types from "./mutation-types";
import { leadsService } from "@/services";
import { messageHelper } from "@/helpers/message_helper";

export const fetchLeadList = async ({ commit }, params) => {
  commit(types.SET_IS_LOADING, true);

  try {
    const response = await leadsService.list(params);

    commit(types.SET_LEAD_LIST, response.data.data);
    commit(types.SET_TOTAL_ITEMS, response.data.meta.count);
  } catch (error) {
    messageHelper.displayError("Ocorreu um erro inesperado.");
  } finally {
    commit(types.SET_IS_LOADING, false);
  }
};

export const fetchSourceList = async ({ commit }, params) => {
  commit(types.SET_IS_LOADING, true);

  try {
    const response = await leadsService.listSource(params);

    commit(types.SET_SOURCE_LIST, response.data.data);
    commit(types.SET_TOTAL_SOURCE_ITEMS, response.data.meta.count);
  } catch (error) {
    messageHelper.displayError("Ocorreu um erro inesperado.");
  } finally {
    commit(types.SET_IS_LOADING, false);
  }
};

// eslint-disable-next-line no-unused-vars
export const getLeadById = async ({ commit }, leadId) => {
  let lead = {};

  try {
    const response = await leadsService.getById(leadId);
    lead = response.data.data;
  } catch (error) {
    messageHelper.displayError("Ocorreu um erro inesperado.");
  }

  return lead;
};

// eslint-disable-next-line no-unused-vars
export const getHistoricById = async ({ commit }, leadId) => {
  let comments = {};

  try {
    const response = await leadsService.getHistoricById(leadId);
    commit(types.SET_HISTORIC_LIST, response.data.data);
  } catch (error) {
    messageHelper.displayError("Ocorreu um erro inesperado.");
  }

  return comments;
};

// eslint-disable-next-line no-unused-vars
export const getEventsById = async ({ commit }, leadId) => {
  let events = {};

  try {
    const response = await leadsService.getEventsById(leadId);
    events = response.data;
  } catch (error) {
    messageHelper.displayError("Ocorreu um erro inesperado.");
  }

  return events;
};

export const createLead = async ({ commit }, payload) => {
  try {
    const response = await leadsService.create(payload);
    commit(types.LEAD_LIST_ADD_ITEM, response.data.data);
  } catch (error) {
    messageHelper.displayError("Ocorreu um erro inesperado.");
  }
};

export const updateLead = async ({ commit }, payload) => {
  try {
    const response = await leadsService.update(payload);
    commit(types.LEAD_LIST_UPDATE_ITEM, response.data.data);
  } catch (error) {
    messageHelper.displayError("Ocorreu um erro inesperado.");
  }
};

export const removeLead = async ({ commit }, id) => {
  try {
    await leadsService.destroy(id);
    commit(types.LEAD_LIST_REMOVE_ITEM, id);
  } catch (error) {
    messageHelper.displayError("Ocorreu um erro inesperado.");
  }
};

export const updateLeadSearch = async ({ commit }, payload) => {
  commit(types.SET_SEARCH, payload);
};

export const unarchiveLead = async ({ commit }, payload) => {
  try {
    await leadsService.unarchive(payload);
    if (payload.id) {
      commit(types.LEAD_LIST_UNARCHIVE_ITEM, payload.id);
    } else {
      payload.lead_ids.forEach(id => {
        commit(types.LEAD_LIST_UNARCHIVE_ITEM, id);
      });
    }
  } catch (error) {
    messageHelper.displayError("Ocorreu um erro inesperado.");
  }
};

export const createComment = async ({ commit }, payload) => {
  try {
    const response = await leadsService.comment(payload);
    commit(types.COMMENT_LIST_ADD_ITEM, response.data.data);
  } catch (error) {
    messageHelper.displayError("Ocorreu um erro inesperado.");
  }
};

// eslint-disable-next-line no-unused-vars
export const createPayment = async ({ commit }, payload) => {
  let payment = {};

  try {
    const response = await leadsService.createPayment(payload);
    payment = response.data.data;
  } catch (error) {
    messageHelper.displayError("Ocorreu um erro inesperado.");
  }

  return payment;
};

// eslint-disable-next-line no-unused-vars
export const getPaymentById = async ({ commit }, id) => {
  let payment = {};

  try {
    const response = await leadsService.getPaymentById(id);
    payment = response.data.data;
  } catch (error) {
    messageHelper.displayError("Ocorreu um erro inesperado.");
  }

  return payment;
};
